import { IViewport } from "@config/appConfig";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import Translate from "@service/Translate";
import { FC } from "react";
import { useSelector } from "react-redux";
import Icon from "../Icon";
import DropDown from "./DropDown";

interface IRouteDetail {
    name: string;
    value?: any;
    label?: string;
    placeholder?: string;
    error?: string;
}

export interface IRoutePicker {
    origin: IRouteDetail;
    destination: IRouteDetail;
}

interface IRoutePickerProps {
    originCode: string;
    destinationCode: string;
    originError: string;
    destinationError: string;
    options: IRoutePicker;
    index: number;
    disabled?: boolean;
    onChange: (name: string, value: any) => void;
    onRouteReverse: () => void;
}


const RoutePicker: FC<IRoutePickerProps> = ({ options: { origin, destination }, originCode, destinationCode, originError, disabled, destinationError, onChange, onRouteReverse, index }) => {
    const { tr } = Translate;
    const { airports, routes, error, width } = useSelector((state: IAppState) => ({
        airports: state.airports,
        routes: state.routes,
        width: state.windowWidth,
        error: state.validationErrors
    }));
    const { small } = Config.get<IViewport>("viewport");

    return (
        <div className="route-picker">
            <div className="route-container">
                <DropDown
                    name={origin.name}
                    id={`${origin.name}${+index}`}
                    value={airports.find(airport => airport.code === originCode)}
                    icon={width <= small ? "icon-map-marker-outline" : ""}
                    label={origin.label}
                    mobileTitle={tr("select_origin")}
                    placeholder={origin.placeholder}
                    error={originError}
                    onChange={onChange}
                    itemDisplayFormat="{cityName} ({airportName})"
                    valueKey="code"
                    dataSource={airports.filter(a =>
                        routes.find(r => r.origin === a.code)).map(a => { return { ...a, locality: routes.sort((a, b) => a.locality! - b.locality!).find(r => r.origin === a.code)?.locality } }).sort((a, b) =>
                            a.locality! - b.locality!)}
                    initialLoadingOptions={{
                        loading: airports.filter(x => routes.find(r => r.origin === x.code))?.length ? false : true,
                        content: error && error[0] && error[0].origin ? <div className="flex flex-center"><Icon name="icon-information" /><span>{tr("err_get_origin")}</span></div> : undefined
                    }}
                    columnMember="locality"
                    autoComplete="off"
                    disabled={disabled}
                    nextElement={`${destination.name}${index}`}
                />
            </div>
            <Icon name={`icon-reverce${disabled ? " disabled" : ""}`} onClick={onRouteReverse} />
            <div className="route-container destination" >
                <DropDown
                    name={destination.name}
                    id={`${destination.name}${index}`}
                    value={airports.find(airport => airport.code === destinationCode)}
                    icon={width <= small ? "icon-map-marker-outline" : ""}
                    label={destination.label}
                    mobileTitle={tr('select_destination')}
                    placeholder={destination.placeholder}
                    error={destinationError}
                    onChange={onChange}
                    itemDisplayFormat="{cityName} ({airportName})"
                    valueKey="code"
                    disabled={disabled}
                    dataSource={airports.filter(a => routes.find(r => r.origin === originCode && r.destination === a.code))}
                    initialLoadingOptions={{
                        loading: airports.filter(a => routes.find(r => r.origin === originCode && r.destination === a.code))?.length ? false : true,
                        content: <div className="flex flex-center"><Icon name="icon-information" /><span>{tr("msg_enter_origin_route_first")}</span></div>
                    }}
                    autoComplete="off"
                    nextElement={`startRange${index}`}
                />
            </div>
        </div>
    );
}

export default RoutePicker;